module.exports = __webpack_public_path__ + "img/0-61.45b98d48.jpg";